'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M864 128h-64v64h32v512h-256v256h-384v-768h32v-64h-64c-17.602 0-32 14.4-32 32v832c0 17.6 14.398 32 32 32h504l232-232v-632c0-17.6-14.4-32-32-32zM640 960v-192h192l-192 192zM768 128h-128v-64c0-35.2-28.8-64-64-64h-128c-35.204 0-64 28.8-64 64v64h-128v128h512v-128zM576 128h-128v-63.886c0.034-0.038 0.072-0.078 0.114-0.114h127.768c0.042 0.036 0.082 0.076 0.118 0.114v63.886z' })
    ));
};